export const CatalogConstants = {
    Payload: 'Payload',
    Edge: 'Edge',
    Bus: 'Bus',
    BusComponents: 'Bus Components',
}


export const BUS_COMPONENTS_TYPES = [
    { label: "Bus OBC", value: "Bus OBC" },
    { label: "Bus OS", value: "Bus OS" },
    { label: "iADCS", value: "iADCS" },
    { label: "GPS", value: "GPS" },
    { label: "Thruster", value: "Thruster" },
    { label: "Payload OBC", value: "Payload OBC" },
    { label: "Payload SSD", value: "Payload SSD" },
    { label: "S-Band Antenna", value: "S-Band Antenna" },
    { label: "X-Band Antenna", value: "X-Band Antenna" },
    { label: "K-Band Antenna", value: "K-Band Antenna" },
    { label: "UHF Antenna", value: "UHF Antenna" },
    { label: "S-Band Radio", value: "S-Band Radio" },
    { label: "X-Band Radio", value: "X-Band Radio" },
    { label: "K-Band Radio", value: "K-Band Radio" },
    { label: "UHF Radio", value: "UHF Radio" },
    { label: "EPS", value: "EPS" },
    { label: "Battery Pack", value: "Battery Pack" },
    { label: "Solar Panel", value: "Solar Panel" }
]


export const ALL_PAYLOAD_INTERFACES = [
    "UART",
    "GPIO",
    "RS485",
    "PCIex1",
    "CAN",
    "I2C",
    "Ethernet",
];
export const ALL_EDGE_INTERFACES = [
    "PCIe",
    "USB",
    "I2C",
    "I2S",
    "SPIO",
    "GPIO"
];

export const ALL_BUS_INTERFACES = [
    "UART",
    "GPIO",
    "RS485",
    "PCIex1",
    "CAN",
    "I2C",
    "Ethernet",
    "PCIe",
    "USB",
    "I2S",
    "SPIO",
]

export const POWER_SINK_COMPONENTS = [
    "Payload",
    "Edge",
    "Bus OBC",
    "Bus OS",
    "iADCS",
    "GPS",
    "Thruster",
    "Payload OBC",
    "Payload SSD",
    "S-Band Antenna",
    "X-Band Antenna",
    "K-Band Antenna",
    "UHF Antenna",
    "S-Band Radio",
    "X-Band Radio",
    "K-Band Radio",
    "UHF Radio",
    "EPS",
    "Battery Pack",
    "Solar Panel"
]

export const DEFAULT_POWER_SINK_DATA = {
    name: '',
    idle_power: '',
    avg_power: '',
    peak_power: '',
    quantity: 1,
    isContinuousLoad: false
}

export const BASIC_BUS_DATA_FIELDS = {
    name: '',
    maxPower: '',
    maxMass: '',
    size: {
        breadth: '',
        width: '',
        height: '',
    },
    inertia: {
        "Ixx": '',
        "Ixy": '',
        "Ixz": '',
        "Iyy": '',
        "Iyz": '',
        "Izz": ''
    },
    maxPayloadSize: '',
    maxPayloadPower: '',
    maxPayloadMass: '',
    simulationParameters: null, // to hold parsed JSON
}

export const DEFAULT_POWER_SINK_FIELDS = [
    { key: "name", label: "Name", placeholder: 'Name' },
    { key: "idle_power", label: "Idle Power (W)", placeholder: 'Idle Power' },
    { key: "avg_power", label: "Average Power (W)", placeholder: 'Average Power' },
    { key: "peak_power", label: "Peak Power (W)", placeholder: 'Peak Power' },
]

export const DEFAULT_INTERFACES = {
    'Payload': ALL_PAYLOAD_INTERFACES,
    'Edge': ALL_EDGE_INTERFACES,
    'Bus': ALL_BUS_INTERFACES,
}

export const PAYLOAD_TYPE_OPTIONS = [
    { value: 'Earth Observation', label: 'Earth Observation' },
    { value: 'Communication', label: 'Communication' },
]

export const PAYLOAD_SUBTYPE_OPTIONS = {
    "Earth Observation": [
        { label: "Imaging", value: "Imaging" },
        { label: "Radar", value: "Radar" },
        { label: "AIS", value: "AIS" },
    ],
    "Communication": [
        { label: "RF", value: "RF" },
        { label: "Optical", value: "Optical" },
    ],
    "Imaging": [
        { label: "Multispectral", value: "Multispectral" },
        { label: "Hyperspectral", value: "Hyperspectral" },
        { label: "Thermal IR", value: "Thermal IR" },
        { label: "SWIR", value: "SWIR" },
    ],
    "Radar": [
        { label: "SAR", value: "SAR" },
        { label: "LIDAR", value: "LIDAR" },
        { label: "Microwave", value: "Microwave" },
    ],
}

export const PAYLOAD_TYPE_SPECIFIC_FIELDS = {
    'Multispectral': [
        {
            label: 'GSD (m)',
            name: 'GSD',
            type: 'text',
            required: true,
        },
        {
            label: 'Swath (km)',
            name: 'Swath',
            type: 'text',
            required: true
        },
        {
            label: 'Front Aperture (cm)',
            name: 'Front Aperture',
            type: 'text',
            required: true
        },
        {
            label: 'Spectral Bands (MS)',
            name: 'Spectral Bands',
            type: 'text',
            required: true
        }
    ],
    'SAR': [
        {
            label: 'Frequency (GHz)',
            name: 'Frequency',
            type: 'text',
            required: true,
        },
        {
            label: 'Antenna Size (m)',
            name: 'Antenna Size',
            type: 'text',
            required: true
        },
        {
            label: 'Pulse Width (μs)',
            name: 'Pulse Width',
            type: 'text',
            required: true
        },
        {
            label: 'Sampling Rate (MHz)',
            name: 'Sampling Rate',
            type: 'text',
            required: true
        }
    ],
    'RF': [
        {
            label: 'Data Rate (Mbps)',
            name: 'Data Rate',
            type: 'text',
            required: true
        },
        {
            label: 'Number of Beams',
            name: 'Number of Beams',
            type: 'text',
            required: true
        },
        {
            label: 'Frequency Bands',
            name: 'Frequency Bands',
            type: 'multiselect',
            options: ["S Band",
                "Ka Band",
                "Ku Band",
                "V Band",
                "E Band",
                "Custom"
            ],
            required: true,
        }
    ]
}

export const EDGE_TYPE_SPECIFIC_FIELDS = [
    {
        label: 'CPU Cores',
        name: 'CPU Cores',
        type: 'longtext',
        required: true,
    },
    {
        label: 'GPU',
        name: 'GPU',
        type: 'longtext',
        required: true
    },
    {
        label: 'Memory (GB)',
        name: 'Memory',
        type: 'text',
        required: true
    },
    {
        label: 'Memory Type',
        name: 'Memory Type',
        type: 'longtext',
        required: true
    },
    {
        label: 'Storage (GB)',
        name: 'Storage',
        type: 'text',
        required: true
    },
    {
        label: 'Performance (TOPs)',
        name: 'Performance',
        type: 'text',
        required: true
    },
    {
        label: 'Cache (MB)',
        name: 'Cache',
        type: 'text',
        required: true
    },
    {
        label: 'Tensor Cores',
        name: 'Tensor Cores',
        type: 'text',
        required: true
    }
]